const React = require('react');
const Home = require('./Home');
const OnlinePayments = require('./OnlinePayments');
const InPersonPayments = require('./InPersonPayments');
const Plugins = require('./Plugins');
const Overview = require('./Overview');

const getLanding = ({ landing, i18n, platform, lang, deviceType, setActiveItem, assetsPath, email, isContactSuscribed, userData, actualUrl, cookieFeedback }) => {
  let landingComponent;
  switch (landing) {
    case 'online-payments':
      landingComponent = (
        <OnlinePayments
          i18n={i18n}
          platform={platform}
          lang={lang}
          deviceType={deviceType}
          setActiveItem={setActiveItem}
          assetsPath={assetsPath}
        />
      );
      break;
    case 'in-person-payments':
      landingComponent = (
        <InPersonPayments
          i18n={i18n}
          platform={platform}
          lang={lang}
          deviceType={deviceType}
          setActiveItem={setActiveItem}
        />
      );
      break;
    case 'overview':
      landingComponent = (
        <Overview
          i18n={i18n}
          platform={platform}
          lang={lang}
          deviceType={deviceType}
          setActiveItem={setActiveItem}
          actualUrl={actualUrl}
          cookieFeedback={cookieFeedback}
        />
      );
      break;
    case 'plugins':
      landingComponent = (
        <Plugins
          i18n={i18n}
          platform={platform}
          lang={lang}
          deviceType={deviceType}
          setActiveItem={setActiveItem}
          assetsPath={assetsPath}
        />
      );
      break;
    case 'home':
      landingComponent = (
        <Home
          i18n={i18n}
          platform={platform}
          lang={lang}
          deviceType={deviceType}
          setActiveItem={setActiveItem}
          userData={userData}
          email={email}
          isContactSuscribed={isContactSuscribed}
          assetsPath={assetsPath}
        />
      );
      break;
    default:
      landingComponent = null;
      break;
  }
  return landingComponent;
};

module.exports = { getLanding };
